<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                ref="master"
                :parentData="parentData"
                @action="masterAction"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('ID action')">
                <a-input
                  v-decorator="['id_action', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown v-bind="fiOptions"
                          endpoint="role"
                          :label="$t('Rol')"
                          :formItemConfig="fiOptions"
                          :decorator="['role_name', { rules: [{ required: true, message: 'Valor requerido'}] }]"
              >
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown v-bind="fiOptions"
                          endpoint="hierarchy_lookup"
                          :label="$t('Estado')"
                          :formItemConfig="fiOptions"
                          :decorator="['status', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="status">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>

    <!-- NUEVO MODAL -->
    <a-modal
      :visible="visible"
      title='Crear / Editar'
      okText='Ok'
      :confirm-loading="loading"
      @cancel="() => (visible = false)"
      @ok="editarNodeAction()"
    >
      <a-form-model :model="iNodeAction" v-bind="fiOptions" :rules="formRules"
                    @submit.native.prevent ref="NodeAction">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-model-item :label="$t('Estado')" prop="status" has-feedback>
              <form-model-dropdown style="width: 100%"
                                   v-model="iNodeAction.status"
                                   endpoint="hierarchy_lookup"
                                   :params="status"
              >
              </form-model-dropdown>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        visible: false,
        loading: false,
        iNodeAction: {},
        formRules: {},
        status: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'node_action',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'editar',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'customDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Item', dataIndex: 'item', sorter: true},
              {title: 'Nombre del rol', dataIndex: 'role_name', sorter: true},
              {title: 'Acción', dataIndex: 'id_action', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'item'},
            {name: 'description'},
            {name: 'parent'},
            {name: 'path'},
            {name: 'path_taskflow'},
            {name: 'priority'},
            {name: 'taskflow'},
            {name: 'type'}
          ]
        }
      }
    },
    methods: {
      initFormRules () {
        this.formRules = {
          status: [{required: true, message: 'Valor requerido'}]
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'customDelete':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('node_action/rnd', {
                    data: action.record
                  })
                    .then(() => {
                      this.$refs.master.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
          case 'editar':
            this.visible = true
            this.iNodeAction = {...action.record}
            break
        }
      },
      editarNodeAction () {
        this.loading = true
        this.$refs.NodeAction.validate(valid => {
          if (valid) {
            return new Promise((resolve, reject) => {
              this.httpClient.getInstance().put('node_action/act', {
                id_action: this.iNodeAction.id_action,
                item: this.item,
                status: this.iNodeAction.status,
                role_name: this.iNodeAction.role_name
              })
                .then(() => {
                  this.$refs.master.$refs.datatable.loadData()
                  resolve()
                  this.loading = false
                  this.visible = false
                })
                .catch((error) => {
                  Mensajes.error('Error', 'No fue posible actualizar')
                  reject(error)
                  this.loading = false
                  this.visible = false
                })
            })
          }
        })
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.initFormRules()
    },
    props: ['item'],
    computed: {
      parentData () {
        return {
          item: this.item
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/NodeAction.vue